import React from "react"
import { type RouteObject } from "react-router-dom"

import { ErrorBoundaryFallback } from "../../../../components/ErrorElement.tsx"
import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { lazyPage } from "../lazyPage.tsx"

const CalendarPage = lazyPage(
  () => import("../../../Calendar/CalendarPage/CalendarPage.tsx")
)
export const calendarRoutes: RouteObject[] = [
  {
    path: "calendar",
    // Without one here the fault reaches the root's error element, which is an
    // ancestor of the navigation — leaving the user nothing to navigate with.
    errorElement: <ErrorBoundaryFallback />,
    element: (
      <PermissionGate pages={["calendar"]}>
        <CalendarPage />
      </PermissionGate>
    )
  }
]
